"use client";

import { Link } from "next-view-transitions";
import { LinkProps } from "next/link";
import { usePathname } from "next/navigation";
import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

import { TipBadge } from "./TipBadge";

type Props = {
  badgeText?: string;
} & LinkProps &
  Omit<ComponentProps<"a">, "ref">;

export const NavbarLink = ({ badgeText, children, ...props }: Props) => {
  const pathname = usePathname();
  const isActive = pathname.includes(props.href);
  return (
    <Link {...props} className={twMerge("relative", props.className)} prefetch>
      <button
        className={twMerge(
          "whitespace-nowrap rounded-md p-2 text-sm font-medium transition",
          isActive
            ? "bg-zinc-900/40 text-white"
            : "text-gray-300 hover:bg-zinc-900/40 hover:text-white"
        )}
      >
        {children}
      </button>
      {badgeText && (
        <TipBadge text={badgeText} className="absolute -right-5 -top-2 z-10" />
      )}
    </Link>
  );
};
